module.exports = __webpack_public_path__ + "img/ceo.cd4250e2.jpg";